<template>
  <div
    v-if="showModal"
    class="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-gray-800 tw-bg-opacity-50 tw-z-50">
    <div
      class="tw-bg-white tw-rounded-lg tw-shadow-lg tw-w-11/12 tw-max-w-4xl tw-max-h-[90vh] tw-overflow-hidden">
      <!-- Top Bar -->
      <div
        class="tw-bg-white tw-flex tw-items-center tw-justify-between tw-px-6 tw-py-4 tw-border-b tw-border-gray-200">
        <!-- Logo on the left -->
        <div class="tw-flex tw-items-center">
          <img
            src="/images/apa_logo_transparent.png"
            alt="APA Insurance"
            class="tw-h-10 tw-w-auto" />
        </div>

        <!-- Amount in the center -->
        <div class="tw-flex-1 tw-text-center">
          <p class="tw-text-xl tw-font-bold" style="color: #114cac">
            Kshs. {{ amount }}
          </p>
        </div>

        <!-- Close button on the right -->
        <button
          @click.stop="closeModal"
          class="tw-text-gray-600 hover:tw-text-gray-800 tw-transition-colors"
          aria-label="Close">
          <v-icon size="28">mdi-close</v-icon>
        </button>
      </div>

      <!-- Iframe Container -->
      <div class="tw-bg-gray-50" style="min-height: 500px">
        <iframe
          v-if="redirectUrl"
          :src="redirectUrl"
          class="tw-w-full tw-border-0"
          style="min-height: 500px"
          title="Pesapal Payment Gateway"
          @load="onIframeLoad" />
        <div
          v-else
          class="tw-flex tw-items-center tw-justify-center"
          style="min-height: 500px">
          <p class="tw-text-gray-500 tw-text-lg">Loading payment gateway...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PesapaliFrame',
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: [String, Number],
      default: '0',
    },
    redirectUrl: {
      type: String,
      default: '',
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    onIframeLoad() {
      // Iframe loaded successfully
    },
  },
};
</script>
